import type React from 'react'
import { useTranslation } from 'react-i18next'

interface AppSwitchToggleProps {
  value: boolean | string | number
  name?: string
  ariaLabel?: string
  ariaLabelledBy?: string
  ariaDescribedBy?: string
  disabled?: boolean
  onChange?: (value: boolean) => void
}

export const AppSwitchToggle: React.FC<AppSwitchToggleProps> = ({
  value,
  name,
  ariaLabel,
  ariaLabelledBy,
  ariaDescribedBy,
  disabled = false,
  onChange,
}) => {
  const { t } = useTranslation()
  const checked = Boolean(value)

  const handleToggle = () => {
    if (!disabled && onChange) {
      onChange(!checked)
    }
  }

  return (
    <>
      {name && <input type="hidden" name={name} value={checked ? 'true' : 'false'} />}
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={
          ariaLabelledBy
            ? undefined
            : (ariaLabel ?? (checked ? t('switch.toggleOn') : t('switch.toggleOff')))
        }
        aria-labelledby={ariaLabelledBy}
        aria-describedby={ariaDescribedBy}
        title={
          !ariaLabel && !ariaLabelledBy
            ? checked
              ? t('switch.toggleOn')
              : t('switch.toggleOff')
            : undefined
        }
        aria-disabled={disabled}
        disabled={disabled}
        onClick={handleToggle}
        className={`relative inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-60 ${checked ? 'border-positive bg-positive' : 'border-border-gray bg-gray-100'}`}
      >
        <span
          aria-hidden="true"
          className={`pointer-events-none absolute left-0.5 size-5 rounded-full border bg-white shadow-[0_0.0625rem_0.0625rem_0_rgba(0,0,0,0.06),0_0.1875rem_0.5rem_0_rgba(0,0,0,0.15)] transition-transform duration-200 ${checked ? 'translate-x-5 border-positive' : 'translate-x-0 border-border-gray'}`}
        />
      </button>
    </>
  )
}
